module.exports = __webpack_public_path__ + "static/media/klarna-logo.6c8d82a8.png";